import { Link } from "react-router-dom";

export function Logo({ className = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-2 group ${className}`} data-testid="brand-logo">
      <span className="relative flex h-7 w-7 items-center justify-center rounded-md bg-kinetic">
        <span className="font-display text-[15px] font-extrabold text-white leading-none">C</span>
      </span>
      <span className="font-display text-lg font-bold tracking-tight text-white">
        Catalina<span className="text-kinetic">.</span>AI
      </span>
    </Link>
  );
}
